export function allStringsAreEmptyOrAllAreNonEmpty(fields: (string | undefined)[]): boolean {
  const allFieldsAreEmpty = fields.every((f) => f == null || f.length === 0);
  const allFieldsAreNonEmpty = fields.every((f) => f != null && f.length > 0);
  return allFieldsAreEmpty || allFieldsAreNonEmpty;
}
